import { initiateVue } from '../javascripts/helpers/vue-helper'

initiateVue()